(function () {
  function safeParse(json) {
    try { return JSON.parse(json); } catch (e) { return null; }
  }

  function nowMs() { return Date.now(); }

  function storageFor(mode) {
    return mode === 'session' ? window.sessionStorage : window.localStorage;
  }

  function getState(key, mode) {
    const st = storageFor(mode);
    const raw = st.getItem(key);
    if (!raw) return null;
    const data = safeParse(raw);
    if (!data) return null;
    if (data.until && nowMs() > data.until) {
      st.removeItem(key);
      return null;
    }
    return data;
  }

  function setState(key, mode, data) {
    const st = storageFor(mode);
    st.setItem(key, JSON.stringify(data));
  }

  function visibleEl(el) {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    return true;
  }

  function anyBlockingToastVisible(selectors) {
    if (!selectors) return false;
    const list = selectors.split(',').map(s => s.trim()).filter(Boolean);
    for (const sel of list) {
      const el = document.querySelector(sel);
      if (visibleEl(el)) return true;
    }
    return false;
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // fallback
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('[data-promo-unlock-toast]');
    if (!root) return;

    const enabled = root.dataset.enabled === 'true';
    if (!enabled) return;

    const offerId = root.dataset.offerId || 'offer';
    const freqMode = root.dataset.frequency || 'day'; // day|session|always
    const days = Math.max(1, parseInt(root.dataset.frequencyDays || '1', 10) || 1);
    const delayMs = Math.max(0, parseInt(root.dataset.delayMs || '2500', 10) || 2500);
    const position = root.dataset.position || 'br';
    const blockSelectors = root.dataset.blockSelectors || '';
    const pageAllowed = root.dataset.pageAllowed === 'true';
    if (!pageAllowed) return;

    root.setAttribute('data-position', position);

    const code = (root.dataset.code || '').trim();
    const key = 'fresure_promo_unlock_' + offerId;

    // Read existing state
    const state = (freqMode === 'always') ? null : getState(key, freqMode);
    if (state && state.state === 'dismissed') {
      root.classList.add('is-hidden');
      return;
    }
    if (state && state.state === 'collapsed') {
      // We no longer use the pill state; treat as dismissed
      dismissAll();
      return;
    }


    const panel = root.querySelector('[data-panel]');
    const pill = root.querySelector('[data-pill]');
    const btnReveal = root.querySelector('[data-reveal]');
    const btnCopy = root.querySelector('[data-copy]');
    const btnClose = root.querySelector('[data-close]');
    const btnPillOpen = root.querySelector('[data-pill-open]');
    const btnPillDismiss = root.querySelector('[data-pill-dismiss]');
    const codeRow = root.querySelector('[data-code-row]');
    const codeEl = root.querySelector('[data-code]');
    const copiedEl = root.querySelector('[data-copied]');

    function persist(nextState) {
      if (freqMode === 'always') return;
      const until = freqMode === 'session' ? null : (nowMs() + days * 86400000);
      setState(key, freqMode, { state: nextState, until: until });
    }

    function showFull() {
      root.classList.remove('is-hidden');
      root.classList.remove('is-collapsed');
      root.classList.add('is-visible');
    }

    function collapseToPill() {
      root.classList.remove('is-visible');
      root.classList.add('is-collapsed');
      persist('collapsed');
    }

    function dismissAll() {
      root.classList.remove('is-visible');
      root.classList.remove('is-collapsed');
      root.classList.add('is-hidden');
      persist('dismissed');
    }

    function revealCode() {
      if (!code) return;
      root.classList.add('has-code');
      if (codeRow) codeRow.hidden = false;
      if (codeEl) codeEl.textContent = code;
      if (btnReveal) btnReveal.disabled = true;
    }

    function markCopied() {
      root.classList.add('is-copied');
      if (copiedEl) copiedEl.hidden = false;
      window.setTimeout(() => {
        root.classList.remove('is-copied');
        if (copiedEl) copiedEl.hidden = true;
      }, 1400);
    }

    // Wire events
    if (btnReveal) btnReveal.addEventListener('click', function () {
      revealCode();
    });

    if (btnCopy) btnCopy.addEventListener('click', function () {
      if (!code) return;
      copyText(code).then(markCopied);
    });

    if (btnClose) btnClose.addEventListener('click', function () {
      dismissAll();
    });


    if (btnPillOpen) btnPillOpen.addEventListener('click', function () {
      showFull();
    });

    if (btnPillDismiss) btnPillDismiss.addEventListener('click', function () {
      dismissAll();
    });

    // Delay show, and avoid showing while cart toasts are visible
    function attemptShow(startedAt) {
      const elapsed = nowMs() - startedAt;
      if (blockSelectors && anyBlockingToastVisible(blockSelectors)) {
        if (elapsed < 12000) {
          window.setTimeout(() => attemptShow(startedAt), 250);
        }
        return;
      }

      // If previously collapsed, show pill only (no auto-open)
      const st2 = (freqMode === 'always') ? null : getState(key, freqMode);
      if (st2 && st2.state === 'collapsed') {
        root.classList.remove('is-hidden');
        root.classList.add('is-collapsed');
        return;
      }

      // Otherwise show full panel
      showFull();
    }

    // If dismissed state is not set, show after delay
    if (!state || (state && state.state !== 'dismissed')) {
      window.setTimeout(() => attemptShow(nowMs()), delayMs);
    }

    // Default code row hidden until reveal
    if (codeRow) codeRow.hidden = true;
  });
})();
